/* eslint-disable react/jsx-no-target-blank */
import Image from 'next/image';
import { Lazy, Navigation, Pagination } from 'swiper';
import Link from 'next/link';

import Carousel, {
  SwiperSlide,
} from '@components/Carousel/next/Carousel/CarouselComponent';
import IsInViewPort from '@components/ui/IsInViewPort';
import {
  selectPromotion,
  viewPromotion,
} from '@utils/newDataLayer/promotionEvents';

import { BannerWrapper, ImageWrapper } from './BannerStyle';

export interface BannerProps {
  images: Array<{
    url?: string;
    alt?: string;
    href?: string;
    id?: string;
  }>;
  imagesWidth?: number;
  imagesHeight?: number;
  logViewImpression?: boolean;
}

const Banner = ({
  images,
  imagesWidth = 960,
  imagesHeight = 278,
  logViewImpression = false,
}: BannerProps) => {
  return (
    <BannerWrapper>
      <Carousel
        paginationShow={Boolean(images.length > 1)}
        slider={Boolean(images.length > 1)}
        preloadImages={false}
        lazy={{
          enabled: true,
        }}
        modules={[Lazy, Navigation, Pagination]}
      >
        {images?.map((item, index) => (
          <SwiperSlide key={index}>
            <ImageWrapper key={item.url}>
              <IsInViewPort
                key={item.id}
                onViewVisible={() => {
                  logViewImpression &&
                    viewPromotion(
                      'Otel Listeleme - Banner',
                      index.toString(),
                      '',
                      ''
                    );
                }}
              >
                <Link
                  href={item?.href as string}
                  target='_blank'
                  title={item.alt}
                  prefetch={false}
                  onClick={() => {
                    logViewImpression &&
                      selectPromotion(
                        'Otel Listeleme - Banner',
                        index.toString(),
                        '',
                        ''
                      );
                  }}
                >
                  {index > 0 ? (
                    <Image
                      src={item.url || '/static/images/setur-static.jpg'}
                      alt={item.alt || 'Setur Görseli Hazırlanmakta'}
                      width={imagesWidth}
                      height={imagesHeight}
                      style={{ objectFit: 'cover' }}
                      loading='lazy'
                    />
                  ) : (
                    <Image
                      priority
                      src={item.url || '/static/images/setur-static.jpg'}
                      alt={item.alt || 'Setur Görseli Hazırlanmakta'}
                      width={imagesWidth}
                      height={imagesHeight}
                      style={{ objectFit: 'cover' }}
                    />
                  )}
                </Link>
              </IsInViewPort>
            </ImageWrapper>
          </SwiperSlide>
        ))}
      </Carousel>
    </BannerWrapper>
  );
};

export default Banner;
